import { formatCurrency } from "@/shared/utils/formatters";
import type { EstateItem } from "@/shared/types/estateTypes";

export function buildMortgageSubtitle(item: EstateItem): string {
  const meta = (item.metadata ?? {}) as Record<string, unknown>;
  const parts: string[] = [];
  if (typeof meta.lender_name === "string" && meta.lender_name) {
    parts.push(meta.lender_name);
  }
  if (item.balance) {
    parts.push(formatCurrency(item.balance));
  }
  if (typeof meta.monthly_payment === "number" && meta.monthly_payment) {
    parts.push(`${formatCurrency(meta.monthly_payment)}/mo`);
  }
  return parts.join(" \u00b7 ");
}

export function buildLoanSubtitle(item: EstateItem): string {
  const meta = (item.metadata ?? {}) as Record<string, unknown>;
  const parts: string[] = [];
  if (typeof meta.lender_name === "string" && meta.lender_name) {
    parts.push(meta.lender_name);
  }
  if (item.balance) {
    parts.push(formatCurrency(item.balance));
  }
  if (typeof meta.monthly_payment === "number" && meta.monthly_payment) {
    parts.push(`${formatCurrency(meta.monthly_payment)}/mo`);
  }
  return parts.join(" \u00b7 ");
}
